import { render, staticRenderFns } from "./index.legacy.vue?vue&type=template&id=f087b354&scoped=true"
import script from "./index.legacy.vue?vue&type=script&lang=js"
export * from "./index.legacy.vue?vue&type=script&lang=js"
import style0 from "./index.legacy.vue?vue&type=style&index=0&id=f087b354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f087b354",
  null
  
)

export default component.exports